import request from '@/api/request'

const quote = '/v1/quote/'
const quoteWithOutLogin = '/v1/quote/'

// 查询 获取股权转让列表
export function stockBasicInfoHomeList (data) {
  return request({
    url: `${quote}/stockBasicInfo/homeList?pageNum=${data.pageNum}&pageSize=${data.pageSize}&productTitle=${data.productTitle}&industry=${data.industry}&keyword=${data.keyword}&minTransferPrice=${data.minTransferPrice}&maxTransferPrice=${data.maxTransferPrice}&investStage=${data.investStage}&province=${data.province}&city=${data.city}&entCustid=${data.entCustid}`,
    method: 'get'
  })
}
// 查询 获取股权转让列表 未登录状态
export function stockBasicInfoHomeListWithOutLogin (data) {
  return request({
    url: `${quoteWithOutLogin}/stockBasicInfo/homeList?pageNum=${data.pageNum}&pageSize=${data.pageSize}&productTitle=${data.productTitle}&industry=${data.industry}&keyword=${data.keyword}&minTransferPrice=${data.minTransferPrice}&maxTransferPrice=${data.maxTransferPrice}&investStage=${data.investStage}&province=${data.province}&city=${data.city}&entCustid=${data.entCustid}`,
    method: 'get'
  })
}
// 获取股权基本信息
export function stockBasicInfoDetail (id) {
  return request({
    url: `${quote}/stockBasicInfo/detail?id=${id}`,
    method: 'get'
  })
}
// 获取股权 基金的重点推荐
export function highlyRecommendInfoList (data) {
  return request({
    url: `${quote}/highlyRecommendInfo/list/home?pageNum=${data.pageNum}&pageSize=${data.pageSize}&type=${data.type}`,
    method: 'get'
  })
}
// 获取行业 转让价格 投资阶段 等等 字典列表
export function sysTypeGroupByCode (data) {
  return request({
    url: `/v1/teamsys/sysTypeGroup/byCode?code=${data}`,
    method: 'get'
  })
}
// 发起预约
export function appointmentInfoSave(data) {
  return request({
    url: `${quote}/appointmentInfo/save`,
    method: 'post',
    data
  })
}
const quoteApi = {
  stockBasicInfoHomeList,
  stockBasicInfoHomeListWithOutLogin
}

export default quoteApi



// WEBPACK FOOTER //
// ./src/api/quoteAPI.js